import view from './skip'
export default view
